import { ReactNode } from 'react';
import styled from 'styled-components';

import { zIndexes } from '../../../utils/zIndexes';

const ActivationOverlay = ({ children }: { children: ReactNode }) => {
  return <ActivationOverlayContainer>{children}</ActivationOverlayContainer>;
};

const ActivationOverlayContainer = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  margin: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${zIndexes('CURIMOTE_TEACHER_WINDOW_CONFIRM')};
  padding: 20px;

  /* Background filter */
  @supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(20px);
  }
  /* slightly transparent fallback for Firefox (not supporting backdrop-filter) */
  @supports not ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background-color: rgba(0, 0, 0, 0.9);
  }
`;

export default ActivationOverlay;
